import { FC, useEffect, useState } from "react";

import { ReactComponent as TimewatchIcon } from "assets/hourglass.svg";
import { ReactComponent as PointIcon } from "assets/point.svg";
import { fireToast } from "services/sweetAlertConfig";

import * as S from "./styles";

interface IProps {
  currentElapsedTime: number;
  isWaiting?: boolean;
}

export const CardTimer: FC<IProps> = ({ currentElapsedTime, isWaiting }) => {
  const [elapsedTime, setElapsedTime] = useState<number>(currentElapsedTime ?? 0);

  const isMoreThan24Hrs = elapsedTime > 86400;

  useEffect(() => {
    setElapsedTime(currentElapsedTime);
  }, [currentElapsedTime]);

  useEffect(() => {
    const oneSecond = 1000;
    const intervalId = setInterval(() => {
      setElapsedTime((prevState) => {
        return prevState + 1;
      });
    }, oneSecond);

    return () => clearInterval(intervalId);
  }, [currentElapsedTime]);

  function getHoursBySeconds(seconds: number): string {
    const date = new Date(seconds * 1000).toISOString();

    const hours = date.slice(11, 19);
    const days = isMoreThan24Hrs ? Math.floor(seconds / 86400) : 0;

    const hoursStringSplit = hours.split(":");

    const [hoursString, minutesString, secondsString] = hoursStringSplit;

    return `${days !== 0 ? `${days}d ` : ""
      }${hoursString}h ${minutesString}min ${secondsString}s`;
  }

  function showCurrentTime() {
    fireToast(
      `Duração da ocorrência: ${getHoursBySeconds(elapsedTime)}`,
      5000,
      "bottom"
    );
  }

  return (
    <S.CardTimer>
      <div className={isWaiting ? "animated" : ""}>
        <TimewatchIcon />
      </div>

      {isMoreThan24Hrs ? (
        <S.DayTimer onClick={showCurrentTime}>
          <p>+24 horas</p>
          <PointIcon />
        </S.DayTimer>
      ) : (
        <p>{!isWaiting ? getHoursBySeconds(elapsedTime) : "--"}</p>
      )}
    </S.CardTimer>
  );
};
